import { createStore } from '@core'
import { IMFO_MESSAGES_STORAGE_KEY } from 'src/business/InfoMessages/InfoMessages'

export type Infomessage = {
    id: number
    important: boolean
    text: string
    warehouseId?: number
}

export const infoMessagesStore = createStore<Infomessage[] | null>(null)

export const overdueStore = createStore<boolean>(false)

export const setInfoMessages = (messages: Infomessage[]) => {
    infoMessagesStore.change(messages)
}

export const clearMessagesOnLogout = () => {
    infoMessagesStore.change(null)

    const storedMessages =
        localStorage.getItem(IMFO_MESSAGES_STORAGE_KEY) || '[]'
    const seenMessageIds = JSON.parse(storedMessages) as Pick<
        Infomessage,
        'id' | 'important'
    >[]

    const nonPriorityMessages = seenMessageIds.filter(
        message => !message.important
    )

    localStorage.setItem(
        IMFO_MESSAGES_STORAGE_KEY,
        JSON.stringify(nonPriorityMessages)
    )
}
